import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

const plugin2 = {
  id:'plugin2',
  afterDraw: (chart) => {

      const {ctx} = chart;
      const xAxis = chart.scales.x;
      const yAxis = chart.scales.y;
      ctx.save();
      chart.data.labels.forEach((label) => {
        const x = xAxis.getPixelForValue(label);
        const y = yAxis.bottom + 18;
        
        ctx.textAlign = 'center';
        ctx.font = 'bold 0.875rem Montserrat';
        ctx.fillStyle = '#748AA1';
        ctx.fillText(label[0], x, y);
        
        ctx.font = '300 0.75rem Montserrat';
        ctx.fillStyle = '#748AA1';
        ctx.fillText(label[1], x, y+14);
      });
      ctx.restore();
  }
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  plugin2
);


const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  stacked: false,
  plugins: {
    plugin1: false,
    datalabels: false,
    legend: {
      display: false,
      usePointerStyle: false
    },
    tooltip: {
      displayColors: false,
      backgroundColor: 'white', 
      bodyFont: {
        weight: 'bold',
        size: 16
      }, 
      callbacks: {
        title: ()=>{
          return ""
        },
        label: (context) => {
          return context.formattedValue;
        },
        labelTextColor: () => {
          return '#31394D'
        },
      }
    }
  },
  scales: {
    x: {
      display: true,
      grid: {
        display: false,
      },
      border: {
        display: false
      },
      ticks: {
        display: false,
        color: 'transparent'
      }
    },
    y: {
      display: false,
    },
    y1: {
      display: false,
    },
  },
  elements: {
    line: {
      tension: 0.4
    }
  },
  layout: {
    padding : {
      bottom: 25,
      left: 80,
      right: 80
    }
  }
};

function convertDateLabel(startDate, endDate) {
  try{
    const convertString = `${startDate.slice(0,4)}/${startDate.slice(4,6)}/${startDate.slice(6,8)} ~ ${endDate.slice(0,4)}/${endDate.slice(4,6)}/${endDate.slice(6,8)}`;

    return convertString;
  }catch(err){
    console.error(err);

    return `${startDate}~${endDate}`;
  }
}


function PatientDetailHabitLineChart({ habitData }) {
  const [chartData, setChartData] = useState({});

  useEffect(()=>{
    const data = {
      labels: habitData.map(e=>[`${e.weekNum}주차`,convertDateLabel(e.startDate, e.endDate)]),
      datasets: [
        {
          data: habitData.map(e=>e.score),
          borderColor: '#2896E9',
          backgroundColor: '#2896E9',
          yAxisID: 'y',
          borderWidth: 1,
          pointStyle: 'circle',
          pointRadius: 2,
          pointBorderColor: '#2896E9',
          pointBorderWidth: 2,
          pointBackgroundColor: '#fff',
          pointHoverRadius: 7,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: '#fff'
        }
      ],
    };
    setChartData({...data});
  },[habitData])

  return Object.keys(chartData).length &&  <Line options={options} data={chartData} />;
}

export default PatientDetailHabitLineChart;